/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/core/CheckEndian.ts
 * @create:      2025-07-01 18:00:59.091
 * @modify:      2025-07-11 21:19:12.965
 * @version:     6.0.0
 * @times:       6
 * @lines:       65
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

/**
 * Determines the endianness of the current environment.
 *
 * Allocates a 2-byte ArrayBuffer and sets its bytes to known values.
 * Checks the resulting 16-bit value to infer whether the system is little-endian or big-endian.
 *
 * @returns {boolean | undefined} Returns `true` if the system is little-endian, `false` if big-endian,
 * or `undefined` if the endianness cannot be determined.
 * 
 * @since 1.0.5
 * @version 2021-12-13
 */
/* istanbul ignore next */
export function CheckEndian(): boolean | undefined {
    const arrayBuffer = new ArrayBuffer(2);
    const uint8Array = new Uint8Array(arrayBuffer);
    const uint16array = new Uint16Array(arrayBuffer);
    uint8Array[0] = 0xAA; // set first byte
    uint8Array[1] = 0xBB; // set second byte
    
    if (uint16array[0] === 0xBBAA) {
        // little endian
        return true;
    }

    if (uint16array[0] === 0xAABB) {
        // big endian
        return false;
    }

    return undefined;
}
